import { Paper, Text, Stack, Group } from '@mantine/core';
import { IconFileText } from '@tabler/icons-react';

export function EmptyReportsState() {
  return (
    <Paper
      shadow="sm"
      p="xl"
      withBorder
      sx={(theme) => ({
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 180,
      })}
    >
      <Stack align="center" spacing="md">
        <Group position="center" spacing="xs">
          <IconFileText size={24} color="gray" />
          <Text size="lg" weight={500}>
            No Open Reports
          </Text>
        </Group>
        <Text color="dimmed" align="center" size="sm">
          There are no open reports to display at this time.
        </Text>
      </Stack>
    </Paper>
  );
} 